export default __webpack_public_path__ + "code.4ed72368ba32f55a.svg";